/* 🤖 this file was generated by svg-to-ts */
export const iconArrowLeft: {
    name: 'arrow_left';
    data: string;
} = {
    name: 'arrow_left',
    data: `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="14" viewBox="0 0 22 14"><path fill="#000" fill-rule="evenodd" d="M.592 7 .6 6.9v-.004l.001-.003.01-.044.008-.033.005-.015a.6.6 0 0 1 .072-.153l.018-.027.037-.047.032-.033L6.867.457a.65.65 0 0 1 .987.838l-.068.081-4.974 4.975 17.946-.001a.65.65 0 0 1 .096 1.293l-.096.007H2.811l4.974 4.974a.65.65 0 0 1-.839.988l-.08-.069L.79 7.466.783 7.46.765 7.44l-.032-.037.05.056a1 1 0 0 1-.077-.093l-.009-.013-.018-.03A.65.65 0 0 1 .592 7"/></svg>`
};
